import { render, staticRenderFns } from "./OrderPollingCheck.vue?vue&type=template&id=3d31f125&"
import script from "./OrderPollingCheck.vue?vue&type=script&lang=ts&"
export * from "./OrderPollingCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports